angular.module('mercury.modules.qa.idealpos.itemsalesreport', []);
